<template>
    <div>
        <v-btn color="primary" @click="onClickCamera" icon><v-icon large>mdi-camera-plus</v-icon></v-btn>
        <v-btn color="primary" @click="onClickFile" icon><v-icon large>mdi-file-plus</v-icon></v-btn>
        <v-btn color="primary" @click="onClickUncategorizedImage" icon v-if="enabledUncategorizedImageSelect"><v-icon large>mdi-download</v-icon></v-btn>
        <Capture v-model="enableCamera" v-if="enableCamera" ref="capture" @onCaptured="onCameraCaptured" />
        <input type="file" id="imageSelector" accept="image/*" style="display:none" v-on:change="onSelectedImage" />
        <UncategorizedImageSelector ref="cameraImageSelector" @onSelectedUncategorizedImages="onSelectedUncategorizedImages" />
    </div>

</template>

<script>
    import fb from '@/firebase/firebase.js'
    import UncategorizedImageSelector from '@/components/tools/UncategorizedImageSelector';
    import Capture from '@/components/tools/CaptureCamera';
    import ImageCompresser from 'browser-image-compression'
    import loadImage from 'blueimp-load-image'

    export default {
        components: {
            Capture,
            UncategorizedImageSelector
        },
        props: {
            // 未分類の撮影画像の選択を有効とするか否か
            enabledUncategorizedImageSelect: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                enableCamera: false
            }
        },
        methods: {
            onClickUncategorizedImage: function () {
                this.$refs.cameraImageSelector.show()
            },
            onClickCamera: function (image) {
                this.enableCamera = true
            },
            onCameraCaptured: function (image) {

                const self = this

                // https://lab.syncer.jp/Web/JavaScript/Snippet/26/
                // バイナリに変換
                var byteString = atob( image.split( "," )[1] ) ;

                // "image/png"
                var mimeType = image.match( /(:)([a-z\/]+)(;)/ )[2] ;

                // バイナリからBlobを作成
                for( var i=0, l=byteString.length, content=new Uint8Array( l ); l>i; i++ ) {
                    content[i] = byteString.charCodeAt( i ) ;
                }

                var blob = new Blob( [ content ], {
                    type: mimeType ,
                } ) ;

                ImageCompresser(blob, {
                    maxSizeMB:1,
                    maxWidthOrHeight: 1280
                }).then(function(v){
                    // ================================
                    // 圧縮された画像をイベントで送信
                    var converter = new FileReader()
                    converter.onload = function (text) {
                        self.$emit("onImportedImage", converter.result)
                    }
                    converter.readAsDataURL(v)
                }).catch(function(error){
                    console.log("image compress error", error)
                })

                // this.$emit("onImportedImage", image)
            },
            onClickFile: function () {
                document.querySelector("#imageSelector").click()
            },
            onSelectedImage: function (e) {
                const self = this

                e.preventDefault()
                if (e.target.files.length == 0) {
                    return
                }
                const file = e.target.files[0]

                console.log(file)

                // メタデータを取得
                loadImage.parseMetaData(file, async function(data) {
                    console.log("meta data", data)

                    // 画像取得のオプション設定
                    // メタデータにExif情報がある時は、そこから Orientation 値を取得、その内容で回転させて取得
                    const options = {
                        canvas: true,
                        maxWidth: 1280
                    }

                    if (data.exif) {
                        options.orientation = data.exif.get("Orientation")
                    }
                    loadImage(
                        file, 
                        function (canvas) {
                            console.log("canvas", canvas)
                            // CanvasからBase64を取得
                            const url = canvas.toDataURL(file.type)
                            console.log("url", url)
                            // Base64をBlobに変換
                            const blob = self.base64ToBlob(url, file.type)
                            // 1MB以内に収まるように画像を圧縮
                            ImageCompresser(blob, {
                                maxSizeMB:1,
                                maxWidthOrHeight: 1280
                            }).then(function(v){
                                // ================================
                                // 圧縮された画像をイベントで送信
                                var converter = new FileReader()
                                converter.onload = function (text) {
                                    self.$emit("onImportedImage", converter.result)
                                }
                                converter.readAsDataURL(v)
                            }).catch(function(error){
                                console.log("image compress error", error)
                            })
                        },
                        options
                    )
                    // console.log("image", image)

                    // const url = image.image.canvas.toDataURL(file.type)
                    // console.log("url", url)
                })

                // // ================================
                // // ファイル読み取り後、圧縮
                // // console.log("image compressing...", e)
                // ImageCompresser(file, {
                //     maxSizeMB:1,
                //     maxWidthOrHeight: 1280
                // }).then(function(v){
                //     // ================================
                //     // 圧縮された画像をイベントで送信
                //     // console.log("image compressed", v)
                //     var converter = new FileReader()
                //     converter.onload = function (e) {
                //         console.log(this)
                //         // console.log(e, converter.result)
                //         // console.log(e)
                //         self.$emit("onImportedImage", converter.result)
                //     }
                //     converter.readAsDataURL(v)
                // }).catch(function(error){
                //     console.log("image compress error", error)
                // })
            },
            onSelectedUncategorizedImages: function (images) {
                console.log("onSelectedUncategorizedImages", images)

                const list = []
                for (var i=0; i<images.length; i++) {
                    list.push(images[i].body)
                }
                this.$emit("onImportedUncategorizedImages", list)
            },
            base64ToBlob(base64, fileType) {
                const bin = atob(base64.replace(/^.*,/, ''));
                const buffer = new Uint8Array(bin.length);
                for (let i = 0; i < bin.length; i++) {
                    buffer[i] = bin.charCodeAt(i);
                }
                return new Blob([buffer.buffer], {
                    type: fileType ? fileType : 'image/png'
                });
            }
        }
    }
</script>
